<div class="product-item">
  <mat-card appearance="outlined" class="fx-col">
    <div class="product-img borderBottom">
      <a class="product-link" [routerLink]="['/product', $safeNavigationMigration(product?.ItemID)]" [queryParams]="{itemType: 'order'}">
        <img [default]="'assets/images/product/no-img.png'"
          [src]="configService.localSettings.Disco.DiscoUrl+'/CMS/Images/Inventory'+$safeNavigationMigration(product?.ImageUrl)" alt="">
        </a>
      </div>
      <div class="product-info-wrapper">
        <div class="title-wrap">
          <h4 class="color1-f-s-16">{{product?.ProductName || '****'}}</h4>
        </div>
        <div class="stars">

        </div>
        <div class="price-wrap fx-row fx-main-start fx-cross-stretch">
          @if (product.OriginalPrice != product?.Prices[0].Price) {
            <p class="color1-f-s-14 p-r-10"><del>{{$safeNavigationMigration(product?.OriginalPrice) | currency:companyService.selectedCurrency.CurrencyCode}}</del></p>
          }
          <p class="color1-f-s-14">{{product?.Prices[0].Price | currency:companyService.selectedCurrency.CurrencyCode}}</p>

        </div>
      </div>
      <div class="thirdContainer fx-col fx-main-center fx-cross-center fx-flex-100-in-col">
        @if (product.AllowAutoship) {
          <div class="subscriptionButton m-b-20">
            <button id="autoship-cart-btn"mat-raised-button color="primary"  (click)="cart1Service.addToCart(product, true, '', true, false, false)"
            [textContent]="(('autoship' | translate)  | slice:0:30) + (('autoship' | translate).length > 30 ? '...' : '')"></button>
          </div>
        }
        @if (!(persistentService.retailData.CurrentSelectedAutoOrder > 0 && utilityService.getAutoshipEditFlag())) {
          <div class="addButton">
            <button id="add-to-cart-btn" mat-raised-button color="primary"
              (click)="cart1Service.addToCart(product, true, '', false, false, false)" translate
            [textContent]="(('add_to_initial_order' | translate)  | slice:0:30) + (('add_to_initial_order' | translate).length > 30 ? '...' : '')"></button>
          </div>
        }
      </div>
    </mat-card>
  </div>
